// @flow
import CustomError from 'error.js';

export const NotFoundError = CustomError.create({
  name: 'NotFoundError',
  message: 'Content not found',
  statusCode: 404,
  redirect: '/404',
  logLevel: 'warn',
});
export const BadRequest = CustomError.create({
  name: 'BadRequest',
  message: 'Bad request',
  statusCode: 400,
  logLevel: 'error',
});
export const CmsConfigError = CustomError.create({
  name: 'CmsConfigError',
  message: 'Cms configuration error',
  statusCode: 500,
  logLevel: 'error',
});
export const RequestFailed = CustomError.create({
  name: 'RequestFailed',
  message: 'Request failed',
  statusCode: 500,
  logLevel: 'error',
});
export const GraphqlError = CustomError.create({
  name: 'GraphqlError',
  message: 'Graphql request failed',
  statusCode: 500,
  logLevel: 'error',
});
export const ClientSideError = CustomError.create({
  name: 'ClientSideError',
  message: 'Client side error',
  statusCode: 500,
  logLevel: 'error',
});
export const OfferNotFound = CustomError.create({ name: 'OfferNotFound' }, NotFoundError);
export const ZoneNotFound = CustomError.create({ name: 'ZoneNotFound' }, NotFoundError);
export const LandingNotFound = CustomError.create({ name: 'LandingNotFound' }, NotFoundError);
export const ResortNotFound = CustomError.create({ name: 'ResortNotFound' }, NotFoundError);
export const PriceNotFound = CustomError.create({ name: 'PriceNotFound' }, NotFoundError);
export const ProposalNotFound = CustomError.create({ name: 'ProposalNotFound' }, NotFoundError);
export const PageNotFound = CustomError.create({ name: 'PageNotFound' }, NotFoundError);

export class ApiException extends Error {
  apiErrors: $ReadOnlyArray<APIError>;

  constructor(errors: $ReadOnlyArray<APIError>) {
    super(...errors);

    this.name = 'ApiException';
    this.apiErrors = errors;
  }
}
